import { AutogenLayoutOpenItemRecapReport } from "./autogen/AutogenLayoutOpenItemRecapReport";

export class OpenItemRecapReport extends AutogenLayoutOpenItemRecapReport {
}
